import { DS_SPACING_UNITS } from '@calm/evexia-design-tokens';

export const STYLE_SECTION_DIVIDER = {
    my: DS_SPACING_UNITS.SECTION,
};
